import "slick-carousel";
import 'slick-carousel/slick/slick.scss';
// import 'slick-carousel/slick/slick-theme.scss';

export const sliderSlick = () => {
    if ($(".slider-slick").length > 0) {
        const $slider = $('.slider-slick');

        $slider.slick({
            dots: true, // Enable dots for custom pagination
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
            prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
            appendDots: $('.we-novosti-pagination'), // Custom pagination container
            customPaging: function (slider, i) {
                return `<button>${i + 1}</button>`; // Numbered buttons
            },
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        dots: true,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        dots: true,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                        dots: true,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        arrows: true,
                        dots: true,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        variableWidth: false,
                        arrows: true,
                        dots: true,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        // Add 'active' class to the current dot
        $slider.on('afterChange', function (event, slick, currentSlide) {
            $('.we-novosti-pagination button')
                .removeClass('active')
                .eq(currentSlide)
                .addClass('active');
        });

        // Set the initial active dot
        $('.we-novosti-pagination button').eq(0).addClass('active');
    }
};

$(function () {
    sliderSlick();
	console.log('Pagination container:', $('.we-novosti-pagination'));

});
